import { useContext } from 'react';

import { FeatureFlagContext } from './feature-flag-context';
import type { FeatureFlagList } from './types';

export const useFeatureFlags: () => {
	features: FeatureFlagList;
	setFeatureFlag: (featureFlagName: string, value: boolean) => void;
} = () => {
	const { features, setFeatureFlag } = useContext(FeatureFlagContext);

	return { features, setFeatureFlag };
};
